import { useCallback } from 'react'

import { RadioGroup } from 'govwell-ui'
import { RadioGroupVariant } from 'govwell-ui/components/Radio/RadioGroup'

import { TanstackField } from '../../../utils/forms'

export type RadioGroupFieldProps<TKey extends string, TValue extends string> = {
  ariaLabel?: string
  caption?: React.ReactNode
  children: React.ReactNode
  errorMessage?: React.ReactNode
  field: TanstackField<TValue | undefined, TKey>
  isInvalid?: boolean
  isRequired?: boolean
  label?: React.ReactNode
  variant?: RadioGroupVariant
  width?: React.CSSProperties['width']
}

const RadioGroupField = <TKey extends string, TValue extends string>({
  ariaLabel,
  caption,
  children,
  errorMessage: propErrorMessage,
  field,
  isInvalid: propIsInvalid,
  isRequired,
  label,
  variant,
  width,
}: RadioGroupFieldProps<TKey, TValue>) => {
  const errorMessage = propErrorMessage || field.state.meta.errors.join(', ')
  const isInvalid = propIsInvalid || !!errorMessage

  const handleValueChange = useCallback(
    (value: TValue) => {
      field.setValue(value)
      field.handleBlur()
    },
    [field]
  )

  return (
    <RadioGroup
      {...(label ? { label } : { ariaLabel: ariaLabel || '' })}
      caption={caption}
      errorMessage={errorMessage}
      isInvalid={isInvalid}
      isRequired={isRequired}
      onValueChange={handleValueChange}
      value={field.state.value}
      variant={variant}
      width={width}
    >
      {children}
    </RadioGroup>
  )
}

export default RadioGroupField
